module.exports = __webpack_public_path__ + "static/media/EB Garamond.cd0b980d.ttf";